export default "__VITE_ASSET__qeNtu4mK__"